import React from "react";
import Header from "../../components/Header/Header";
import UserFavorites from "../../sections/UserFavorites/UserFavorites";
import "./Favorites.css";

function Favorites() {
  return (
    <main className="Favorites">
      <Header
        title="Your Favorite Collection"
        subtitle="Revisit the stories you love most. Explore your handpicked favorites and dive back into unforgettable journeys."
        actionBtn="Start reading"
      />
      <UserFavorites />
    </main>
  );
}

export default Favorites;
